import React from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../store/actions/index';
import { useTranslation } from 'react-i18next';

const DeleteModal = (props) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleSubmit = () => {
    dispatch( props.onSubmitAction() ).then( dispatch(hideModal()) ).then( props.redirectTo() );
  }
  
  const submitTitle = () => {
    return (props.submitTitle === undefined)? t( 'modals.common.button.delete' ) : props.submitTitle
  }

  return (
  	<Modal show={true} onHide={props.hideModal} animation={true}>
  		<div className="modal-header">
  			<h5 className="modal-title">{props.modalTitle}</h5>
  			<button type="button" onClick={props.hideModal} className="close btn btn-round" data-dismiss="modal" aria-label="Close"> <i className="material-icons">close</i>
  			</button>
  		</div>
  		<Modal.Body>
        {props.children}
  		</Modal.Body>
  		<Modal.Footer>
  			<Button variant="secondary" onClick={props.hideModal}>{ t( 'modals.common.button.close' ) }</Button>
  			<button type="submit" onClick={handleSubmit} className="btn btn-primary">{submitTitle()}</button>
  		</Modal.Footer>
  	</Modal>
  )
}


const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModal())
})

export default connect(null, mapDispatchToProps)(DeleteModal)



// WEBPACK FOOTER //
// ./src/components/Modals/DeleteModal.js